@if (!browserCompatible) {
  <div id="incompatible-browser">
    <div>{{message}}</div>
  </div>
}